import React from "react";
import AppRoutes from "routes/AppRoutes";

function App() {
  return (
    <div className="min-h-[100dvh] flex flex-col">
      <AppRoutes />
    </div>
  );
}

export default App;
